// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { screenSmMax, screenXsMax, screenSmMin, spacer4, spacer8, spacer12, spacer16, spacer32, spacer40, spacer56, IconArrowRight, Type } from '@spotify-internal/encore-web';
import { formatText, fixHref } from '../../../utils';
import { ButtonTertiaryAsLink, fadeInAnimation, withAnimationContext, DELAYS } from '../../../ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RelatedLinkBox = styled.div.withConfig({
  displayName: "RelatedLink__RelatedLinkBox",
  componentId: "sc-1kjvm0y-0"
})(["@media (max-width:", "){padding:", " ", ";}@media (min-width:", "){padding:", " ", ";}"], screenXsMax, spacer32, spacer12, screenSmMin, spacer40, spacer40);
var Headline = withAnimationContext(styled(Type.h1).attrs({
  variant: 'celloCanon'
}).withConfig({
  displayName: "RelatedLink__Headline",
  componentId: "sc-1kjvm0y-1"
})(["", ";padding-bottom:0px;"], fadeInAnimation(DELAYS.FIRST)));
var Subtext = withAnimationContext(styled(Type.p).attrs({
  variant: 'ballad'
}).withConfig({
  displayName: "RelatedLink__Subtext",
  componentId: "sc-1kjvm0y-2"
})(["", ";@media (max-width:", "){width:100%;}"], fadeInAnimation(DELAYS.SECOND), screenSmMax));
var Description = withAnimationContext(styled(Type.p).attrs({
  variant: 'viola'
}).withConfig({
  displayName: "RelatedLink__Description",
  componentId: "sc-1kjvm0y-3"
})(["", ";"], fadeInAnimation(DELAYS.THIRD)));
var TextContainer = styled.div.withConfig({
  displayName: "RelatedLink__TextContainer",
  componentId: "sc-1kjvm0y-4"
})(["display:flex;flex-direction:row;justify-content:space-between;flex:1;padding-bottom:", ";@media (max-width:", "){flex-direction:column;padding-bottom:", ";}"], spacer56, screenSmMax, spacer8);
var LinkBox = styled.div.withConfig({
  displayName: "RelatedLink__LinkBox",
  componentId: "sc-1kjvm0y-5"
})(["@media (max-width:", "){padding-top:0px;}"], screenSmMax);
var InnerTextContainer = styled.div.withConfig({
  displayName: "RelatedLink__InnerTextContainer",
  componentId: "sc-1kjvm0y-6"
})(["text-align:right;display:flex;flex-direction:column;width:65%;align-items:flex-end;@media (max-width:", "){align-items:flex-start;text-align:left;padding-bottom:", ";}"], screenSmMax, spacer16);
var RelatedTextLink = withAnimationContext(styled(ButtonTertiaryAsLink).withConfig({
  displayName: "RelatedLink__RelatedTextLink",
  componentId: "sc-1kjvm0y-7"
})(["", ";padding:0;color:", ";&:hover:not(:focus):not(:disabled){transform:none;color:", ";}svg{padding-left:", ";padding-bottom:", ";vertical-align:middle;}"], fadeInAnimation(DELAYS.FOURTH), function (_ref) {
  var theme = _ref.theme;
  return theme.box.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return hexToRgba(theme.box.text, 0.25);
}, spacer8, spacer4));
var TRACK_CAT = 'module-relatedLinksModule';
export var RelatedLink = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var _ref3$relatedLink = _ref3.relatedLink,
      relatedLink = _ref3$relatedLink === void 0 ? {} : _ref3$relatedLink;
  return /*#__PURE__*/_jsxs(RelatedLinkBox, {
    ref: ref,
    children: [/*#__PURE__*/_jsxs(TextContainer, {
      children: [/*#__PURE__*/_jsx(Headline, {
        children: relatedLink.headline
      }), /*#__PURE__*/_jsxs(InnerTextContainer, {
        children: [/*#__PURE__*/_jsx(Subtext, {
          dangerouslySetInnerHTML: {
            __html: formatText(relatedLink.subtext)
          }
        }), /*#__PURE__*/_jsx(Description, {
          children: relatedLink.description
        })]
      })]
    }), /*#__PURE__*/_jsx(LinkBox, {
      children: /*#__PURE__*/_jsxs(RelatedTextLink, {
        href: fixHref(relatedLink.link),
        track: [TRACK_CAT, "Link - ".concat(relatedLink.linkText)],
        children: [relatedLink.linkText, /*#__PURE__*/_jsx(IconArrowRight, {})]
      })
    })]
  });
});